{
    "Authentication_LoginButton": "Anmelden",
    "LoginForm_LoginTitle": "Melden Sie sich bei Ihrem Konto an",
    "LoginForm_WelcomeBack": "Willkommen zurück! Bitte geben Sie Ihre Daten ein.",
    "LoginForm_Email": "Benutzername",
    "LoginForm_EmailRequired": "E-Mail ist erforderlich",
    "LoginForm_InvalidEmail": "Der Benutzername muss eine E-Mail-Adresse sein",
    "LoginForm_EmailPlaceholder": "Geben Sie Ihre E-Mail ein",
    "LoginForm_Password": "Passwort",
    "LoginForm_PasswordRequired": "Passwort erforderlich ist",
    "LoginForm_PasswordPlaceholder": "••••••••",
    "LoginForm_RememberMe": "Erinnere dich an mich",
    "LoginForm_ForgotPassword": "Passwort vergessen",
    "LoginForm_SignIn": "Anmelden",
    "NAME": "Authentication",
    "LoginForm_Username": "Benutzername",
    "LoginForm_UsernameRequired": "Benutzername ist erforderlich",
    "LoginForm_UsernamePlaceholder": "Geben Sie Ihren Benutzernamen ein",
    "LoginForm_CME": "CME",
    "LoginForm_Or": "(Oder)",
    "LoginForm_Server": "Server",
    "LoginForm_ServerPlaceholder": "Bitte wählen Sie einen Server aus, bei dem Sie sich anmelden möchten",
    "LoginForm_LoginLanding_UserOnMultipleServices": "Dieser Benutzername ist bereits für mehrere Dienste gültig. Bitte geben Sie zusätzliche Informationen zur Identifizierung Ihres Benutzers an.",
    "LoginForm_LoginLanding_UserNonAdmin_Error": "Beim Anmelden bei Ihrem Konto ist ein Problem aufgetreten. Wenden Sie sich zur Behebung des Problems an Ihren Administrator.",
    "LoginForm_LandingPage_NextButton": "Weitermachen",
    "Authentication_ChangeBrowserProfile": "Browserprofil ändern",
    "LoginForm_LoginLanding_User_Not_Found_Error": "Wir konnten den von Ihnen eingegebenen Benutzernamen nicht finden. Bitte überprüfen Sie ihn und versuchen Sie es erneut."
}